import {Directive, HostListener, Input} from '@angular/core';
import {NgControl} from '@angular/forms';

@Directive({selector: '[inputUpperCase]', standalone: false})
export class InputUpperCaseDirective {

    @Input() inputUpperCase: string = "";

    constructor(private readonly control: NgControl) {}

    @HostListener('input', ['$event']) onInput(event: any): void {
        if(this.control.control)
            this.control.control.setValue(event.target.value.toUpperCase());
    }
}
